import { Draft } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

function editFailure(draft: Draft<IWorkerData>) {
  draft.edit.config.isLoading = false;
}

export default editFailure;
